<template>
  <v-container>
    <v-btn
      color="primary arr"
      style="
        background: linear-gradient(135deg, #2a8b8b, #4cb8b8);
        color: white;
        border-radius: 12px;
        padding: 6px 20px;
      "
      @click="dialog = true"
    >
      Show Platforms
    </v-btn>

    <v-dialog v-model="dialog" max-width="800px" scrollable>
      <v-card class="pa-2 pa-sm-4">
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="text-h6">Platforms</span>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider class="mb-2" />

        <v-card-text>
          <v-row dense v-if="platforms.length>0">
            <v-col
              cols="12"
              v-for="(users, platform) in platforms"
              :key="platform"
            >
              <v-card outlined elevation="0">
                <v-card-title
                  @click="togglePlatform(platform)"
                  class="d-flex justify-space-between align-center"
                  style="cursor: pointer"
                >
                  <div class="d-flex ga-4 aligin item-center">
                    <span v-if="platform === 'Facebook'">
                      <img
                        :src="facebookIcon"
                        style="width: 1.9rem; height: 1.9rem"
                        alt="Facebook"
                      />
                    </span>
                    <span v-if="platform === 'Snapchat'">
                      <img
                        :src="snapchatIcon"
                        style="width: 1.9rem; height: 1.9rem"
                        alt="Snapchat"
                      />
                    </span>
                    <span v-if="platform === 'x'">
                      <img
                        :src="xIcon"
                        style="width: 1.9rem; height: 1.9rem"
                        alt="x"
                      />
                    </span>
                    <span v-if="platform === 'Tiktok'">
                      <img
                        :src="tiktokIcon"
                        style="width: 1.9rem; height: 1.9rem"
                        alt="Tiktok"
                      />
                    </span>
                    <span>{{ platform }}</span>
                  </div>
                  <v-icon>
                    {{
                      expandedPlatform === platform
                        ? "mdi-chevron-up"
                        : "mdi-chevron-down"
                    }}
                  </v-icon>
                </v-card-title>

                <v-expand-transition>
                  <v-card-text v-if="expandedPlatform === platform">
                    <v-radio-group v-model="selectedUsers[platform]">
                      <v-radio
                        v-for="(user, index) in users"
                        :key="index"
                        :value="user.userId"
                      >
                        <template #label>
                          <div>
                            <strong>{{ user.name }}</strong
                            ><br />
                            <small class="text-grey">{{ user.userId }}</small
                            ><br />
                            <small v-if="user.org" class="text-caption">{{
                              user.org
                            }}</small>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-card-text>
                </v-expand-transition>
              </v-card>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" class="text-center">
              <!-- <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader> -->
              No available accounts
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="my-2" />

        <v-card-actions class="justify-end">
          <v-btn
            @click="clearSelection"
            style="
              border: 1px solid #2a8b8b;
              color: #2a8b8b;
              background-color: transparent;
              border-radius: 12px;
              padding: 6px 20px;
              margin-right: 10px;
              font-weight: bold;
              text-transform: capitalize;
            "
          >
            Clear
          </v-btn>

          <v-btn
            @click="getTableData"
            style="
              background: linear-gradient(135deg, #2a8b8b, #4cb8b8);
              color: white;
              border-radius: 12px;
              padding: 6px 20px;
            "
          >
            Done
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { adsPerformance } from "@/store/AdsPerformance/ads_performance";
import facebookIcon from "@/assets/soft-ware-img/facebook-post-select.svg";
import snapchatIcon from "@/assets/soft-ware-img/snapchat-logo-svgrepo-com.svg";
import xIcon from "@/assets/soft-ware-img/x-twitter-icons.svg";
import tiktokIcon from "@/assets/soft-ware-img/tikTopkcampaign.svg";
import apiClient from "@/core/buildRequest";
const dialog = ref(true);
const expandedPlatform = ref(null);
const store = adsPerformance();

const rawData = ref([]);
const platforms = ref({});
const selectedUsers = ref({
  Tiktok: null,
  Facebook: null,
  Snapchat: null,
});

const togglePlatform = (platform) => {
  expandedPlatform.value =
    expandedPlatform.value === platform ? null : platform;
};

const getTableData = () => {
  store.getData();
  dialog.value = false;
};

// Watchers
watch(
  () => selectedUsers.value.Facebook,
  (val) => {
    store.facebook_ad_account_id = val;
    if (store.selectedPlatform) store.selectedPlatform = null;
  }
);
watch(
  () => selectedUsers.value.Tiktok,
  (val) => {
    store.tiktok_advertiser_id = val;
    if (store.selectedPlatform) store.selectedPlatform = null;
  }
);

watch(
  () => selectedUsers.value.Snapchat,
  (val) => {
    store.snap_ad_account_id = val;
    if (store.selectedPlatform) store.selectedPlatform = null;
  }
);
const clearSelection = () => {
  selectedUsers.value = {
    TikTok: null,
    Facebook: null,
    Snapchat: null,
  };
};
const fetchApiData = async function fetchAccounts() {
  try {
    const response = await apiClient.get("/ad-performance/get/all/accounts");
    rawData.value = response.data.data;
  } catch (error) {
    console.error(
      "❌ Failed to fetch accounts:",
      error.response?.data?.msg || error.message
    );
  }
};
// Mocked or fetched data assignment
onMounted(async () => {
  await fetchApiData();

  platforms.value = rawData.value.reduce((acc, item) => {
    const provider =
      item.provider.charAt(0).toUpperCase() +
      item.provider.slice(1).toLowerCase();

    if (!acc[provider]) acc[provider] = [];

    acc[provider].push({
      name: item.account_name,
      userId: item.id,
    });

    return acc;
  }, {});
});
</script>

<style scoped>
.v-card-text > .v-input {
  background-color: #f7f7f6;
  border-radius: 0.25rem;
  padding: 1rem;
}
.v-radio-group .v-input__details {
  display: none;
}
.v-container {
  padding: 0;
}
.arr {
  background: linear-gradient(135deg, rgb(42, 139, 139), rgb(76, 184, 184));
  color: white;
  border-radius: 12px;
  padding: 0.3rem;
  height: 3rem;
  font-size: 0.7rem;
  width: 100%;
  margin: 0.7rem 0;
}
</style>
